













































































































import Vue, { VueConstructor } from 'vue'
import VueEvents from 'vue-events'
import { Vuetable, VuetablePagination, VuetableFieldCheckbox } from 'vuetable-2'
import { config } from '@/config'
import TableHeader from '@/pages/common/parts/table-header/TableHeader.vue'
import TooltipCell from '@/pages/common/parts/tooltip-cell/TooltipCell.vue'
import GeneralFilter from '@/pages/common/general-filter/GeneralFilter.vue'
import ContextMenu from '@/pages/common/parts/context-menu/ContextMenu.vue'
import { ContextMenuType } from '@/pages/common/parts/context-menu/types'
import {
  $isLoading,
  requestDeleteGroups,
  $refreshPage,
  groupsPageMounted,
  setIsLoading,
} from '@/pages/users/groups/list/model/users-groups-page.model'
import { noInternetToastEvent } from '@/features/toasts/toasts.model'
import { DEFAULT_ID } from '@/pages/common/constants'
import { loadConfirmDeleteModal } from '@/pages/common/modals/confirm-delete/confirm-delete-modal.model'
import { loadRequestDeleteModal } from '@/pages/common/modals/request-delete/request-delete-modal.model'
import { $permissions } from '@/features/session'
import {
  RefsType,
  HttpOptionsType,
  DisplayContextMenuPayload,
  CommonInteractedItemParams,
} from '@/pages/common/types'
import { navigatePush } from '@/features/navigation/navigationMethods'
import RequestDeleteModal from '@/pages/common/modals/request-delete/RequestDeleteModal.vue'
import ConfirmDeleteModal from '@/pages/common/modals/confirm-delete/ConfirmDeleteModal.vue'
import NoDataContent from '@/pages/common/parts/no-data-content/NoDataContent.vue'
import { combineRouteQueries, computeSortParam, isQueryParamsEquelToPage } from '@/features/lib'
import LoaderBig from '@/pages/common/parts/internal-loader-blocks/BigLoader.vue'
import { TableHeaderItem } from '@/pages/common/parts/table-header/types'
import ActionsButton from '@/pages/common/parts/actions/ActionsButton.vue'
import { showContextMenu } from '@/pages/common/parts/context-menu/context-menu.model'
import { userGroupsTableFields, searchFieldsData } from '@/pages/users/groups/list/model/constants'
import GroupsHeader from '@/pages/users/groups/list/parts/GroupsHeader.vue'
import TooltipFilter from '@/pages/users/groups/list/parts/TooltipFilter.vue'
import {
  userGroupsFilters,
  userGroupsPageParams,
  exportUserGroupsList,
} from '@/pages/users/groups/list/model/users-groups-filters.model'
import { reset } from '@/pages/common/general-filter/general-filter.model'
import { toggleVisibility, $visibility } from '@/pages/users/groups/list/model/tooltip-filter.model'
import { axiosClient } from '@/lib/request'
import { getActionsDisplayConditions } from '@/pages/common'
import { getGroupsActions } from '@/pages/users/groups/list/constants'

Vue.use(VueEvents)
Vue.component('VuetableFieldCheckbox', VuetableFieldCheckbox)

export default (
  Vue as VueConstructor<
    Vue & {
      $refs: RefsType
    }
  >
).extend({
  name: 'GroupsPage',
  components: {
    Vuetable,
    VuetablePagination,
    GroupsHeader,
    TableHeader,
    GeneralFilter,
    TooltipFilter,
    TooltipCell,
    ContextMenu,
    ActionsButton,
    NoDataContent,
    ConfirmDeleteModal,
    RequestDeleteModal,
    LoaderBig,
  },
  effector: {
    $visibility,
    $isLoading,
    $refreshPage,
    $filterParams: userGroupsFilters.store.$filterParams,
    $pageParams: userGroupsPageParams.store.$pageParams,
    $treeView: userGroupsPageParams.store.treeView,
    $currentPage: userGroupsPageParams.store.currentPage,
    $permissions,
  },
  data() {
    return {
      interactedItemId: DEFAULT_ID,
      contextMenuType: 'item' as ContextMenuType,
      contextMenuClickedCoordinates: { x: 0, y: 0 },
      searchFields: searchFieldsData,
      fields: userGroupsTableFields,
      total: 0,
      selectedRows: [] as number[],
      showDeleteModalType: 'groups',
    }
  },
  computed: {
    apiUrl(): string {
      return `${config.BACKEND_URL}/api/user-app/groups/`
    },
    selectedIds(): number[] {
      if (this.selectedRows.length && !this.$treeView) {
        return this.selectedRows
      }
      if (this.interactedItemId !== DEFAULT_ID) {
        return [this.interactedItemId]
      }
      return []
    },
    tableHeaderItems(): TableHeaderItem[] {
      const displayConditions = getActionsDisplayConditions('tableHeader', this.selectedRows.length)
      return getGroupsActions(displayConditions, this.$permissions!)
    },
  },
  watch: {
    $refreshPage: {
      handler(newVal) {
        if (newVal) this.$refs.vuetable.reload()
        this.removeSelection()
      },
    },
    $pageParams: {
      handler(newVal) {
        if (!isQueryParamsEquelToPage(this.$route.query, newVal)) {
          this.$router.replace(combineRouteQueries(this.$route.query, newVal))
        }
      },
    },
    $treeView: {
      handler(newVal) {
        if (newVal) this.removeSelection()
      },
    },
  },
  methods: {
    changeFilter: userGroupsFilters.methods.changeFilter,
    resetFilters: userGroupsFilters.methods.resetFilters,
    applyFilters: userGroupsFilters.methods.applyFilters,
    toggleTreeView: userGroupsPageParams.methods.toggleTreeView,
    changePage: userGroupsPageParams.methods.changePage,
    queryToParams: userGroupsPageParams.methods.queryToParams,
    toggleVisibility,
    exportUserGroupsList,
    setIsLoading,
    async myFetch(apiUrl: string, httpOptions: HttpOptionsType) {
      const request = axiosClient.get(apiUrl, {
        params: { ...httpOptions.params, sort: computeSortParam(httpOptions.params.sort) },
      })
      return request
    },
    onPaginationData(paginationData: any) {
      this.total = paginationData.total
      this.$refs.pagination.setPaginationData(paginationData)
      this.removeSelection()
    },
    onChangePage(page: any) {
      this.$refs.vuetable.changePage(page)
      this.changePage(page)
    },
    onFilterSet() {
      this.applyFilters()
      Vue.nextTick(() => this.$refs.vuetable.refresh())
    },
    onFilterReset() {
      this.resetFilters()
      toggleVisibility(false)
      reset() // search string and field
      Vue.nextTick(() => this.$refs.vuetable.reload())
    },
    onRemoveGroups() {
      const payload = this.selectedIds
      this.showDeleteModalType = 'groups'
      this.$permissions!.users_group_groups.can_edit
        ? loadConfirmDeleteModal(payload)
        : loadRequestDeleteModal(payload)
    },
    onEditGroup() {
      const payload = this.selectedIds[0]
      navigatePush({
        name: 'edit-group',
        params: { id: `${payload}` },
      })
    },
    async handleConfirmDelete(ids: number[], type: string) {
      if (type === 'groups') {
        await requestDeleteGroups({ groups: ids })
        this.$refs.vuetable.reload()
        this.removeSelection()
      }
    },
    async sendRequestDeleteLesson(comment: string, ids: number[]) {
      await requestDeleteGroups({ groups: ids, ticket_comment: comment })
      this.$refs.vuetable.reload()
      this.removeSelection()
    },
    removeSelection() {
      this.$refs.vuetable.selectedTo = []
      this.selectedRows = []
    },
    handleLoadError(res: any) {
      if (!res.response) {
        noInternetToastEvent()
      }
    },
    headerActionsButtonClick(event: MouseEvent) {
      this.handleActionsClick({
        data: { id: this.selectedIds[0] },
        event,
        type: 'header-actions',
      })
    },
    tableActionsButtonClick(event: MouseEvent, id: number) {
      this.handleActionsClick({
        data: { id },
        event,
        type: 'item',
      })
    },
    handleActionsClick({ data, event, type }: CommonInteractedItemParams) {
      this.handleInteractedItemData(data)
      this.displayContextMenu({ id: data.id, type, coordinates: { x: event.x, y: event.y } })
    },
    handleRightClick({ data, event, type }: CommonInteractedItemParams) {
      event.preventDefault()
      this.handleInteractedItemData(data)
      this.displayContextMenu({ id: data.id, type, coordinates: { x: event.x, y: event.y } })
    },
    handleInteractedItemData(data: { id: number }) {
      this.interactedItemId = data.id
    },
    displayContextMenu({ id, type, coordinates: { x, y } }: DisplayContextMenuPayload) {
      this.interactedItemId = id
      this.contextMenuType = type
      this.contextMenuClickedCoordinates = { x, y }
      showContextMenu()
    },
    handleRowClick(res: any) {
      if (res.event.target.closest('.actions-activator')) return
      const { selectedTo } = this.$refs.vuetable
      if (selectedTo.length === 0) selectedTo.push(res.data.id)
      else if (selectedTo.find((el: number) => el === res.data.id)) {
        selectedTo.splice(selectedTo.indexOf(res.data.id), 1)
      } else selectedTo.push(res.data.id)
      this.selectedRows = this.$refs.vuetable.selectedTo
    },
    allToggled(isSelected: boolean) {
      if (isSelected) this.selectedRows = this.$refs.vuetable.selectedTo
      else this.selectedRows = []
    },
    getUserName(user: { id: number; first_name: string; last_name: string } | null) {
      return user ? `${user.first_name} ${user.last_name}` : '–'
    },
    endLoading() {
      setTimeout(() => {
        this.setIsLoading(false)
      }, 700)
    },
  },
  mounted() {
    groupsPageMounted()
  },
  created() {
    this.queryToParams(this.$route.query)
  },
  destroyed() {
    this.resetFilters()
  },
})
